import { combineReducers } from 'redux';
import { AuthConstants } from 'constants/auth';
import fetch from './fetch';
import workflow from './workflow';
import fromRoute from './from';
import bankStatements from './bankStatements';

const appReducer = combineReducers({
  fetch,
  workflow,
  fromRoute,
  bankStatements,
});

export default (state, action) => {
  const myState = action.type === AuthConstants.AUTH_SIGN_OUT ? undefined : state;
  return appReducer(myState, action);
};